import { render, staticRenderFns } from "./task-item.vue?vue&type=template&id=42a5ac30&scoped=true"
import script from "./task-item.vue?vue&type=script&lang=js"
export * from "./task-item.vue?vue&type=script&lang=js"
import style0 from "./task-item.vue?vue&type=style&index=0&id=42a5ac30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5ac30",
  null
  
)

export default component.exports